import { useSearchParams } from "@remix-run/react";
import { isValidTabKey, TabKey, TAB_KEYS } from "../types";

/**
 * Custom hook for managing active tab state
 * Handles URL parameter validation and provides safe tab resolution
 */
export function useActiveTab() {
  const [searchParams] = useSearchParams();
  
  /**
   * Get the current active tab from URL parameters with validation
   * Falls back to default tab if invalid or missing
   */
  const activeTab: TabKey = (() => {
    const tabParam = searchParams.get("tab");
    return (tabParam && isValidTabKey(tabParam)) 
      ? tabParam 
      : TAB_KEYS.BOARD_OF_DIRECTORS;
  })();

  return {
    activeTab,
  };
}